import React from 'react';
import { useNavigate } from "react-router-dom";
import { process } from "@progress/kendo-data-query";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { SpheraButtonEx, SpheraDropdownEx, SpheraTooltip } from "@sphera-cloud/component-ui-reactjs";
import useFetchWithMsal from '../services/useFetchWithMsal';
import { apiRoutes } from '../services/apiRoutes';
import dateFormats from "../Data/dateFormats.json";
import { DateFormater } from "../services/DateFormater"
import { HistoryGrid } from '../components/Grid/HistoryGrid';
import { Layout } from '../components/MasterPage/Layout';
import timezones from '../Data/timezones.json';

export function History(props) {
	let maxDate = new Date();
	if (maxDate.getUTCDate() !== maxDate.getDate())
		maxDate = new Date(maxDate.setDate(maxDate.getUTCDate()));
	const [dateFormatFilter, setdateFormatFilter] = React.useState("dd/MM/yyyy hh:mm:ss a"); 
	const statusTypes = [
		{
			status: props.localizations.Inactive,
			statusId: 0
		},
		{
			status: props.localizations.Active,
			statusId: 1
		},
		{
			status: props.localizations.Pending,
			statusId: 2
		},
		{
			status: props.localizations.Failed,
			statusId: 3
		},
		{
			status: props.localizations.Archived,
			statusId: 4
		}
	];

	const options = [
		{ value: 1, label: props.localizations.IncludeActive },
		{ value: 2, label: props.localizations.IncludeInactive },
		{ value: 3, label: props.localizations.IncludePending },
		{ value: 4, label: props.localizations.IncludeFailed },
	];

	const scopeOptions = [
		{ value: "Internal", label: props.localizations.InternalProprietary },
		{ value: "Public", label: props.localizations.Public },
	];
	if (props.currentTenent.IsViewArchivedDocumentsUser)
		scopeOptions.push({ value: "Archived", label: props.localizations.Archived });

	const { adjustForTimezone } = DateFormater();
	let navigate = useNavigate();

	const [downloadCsv, setdownloadCsv] = React.useState(false);
	const [showExportInfo, setShowExportInfo] = React.useState(false);
	const [exportInfoMsg, setExportInfoMsg] = React.useState("");
	const [showColumnSelect, setshowColumnSelect] = React.useState(false);
	const [buttonsConfig, setbuttonsConfig] = React.useState([]);

	const [historyData, sethistoryData] = React.useState([]);
	const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
	const [pending, setPending] = React.useState(false);

	const urlParams = new URLSearchParams(window.location.search);
	let initialScope = "Internal";
	if (urlParams.get('searchArchive') === "true" && props.currentTenent.IsViewArchivedDocumentsUser)
		initialScope = "Archived";
	const [searchScope, setsearchScope] = React.useState(initialScope);

	const [portals, setportals] = React.useState([]);
	const [selectedPortal, setselectedPortal] = React.useState(null);

	const [includeActive, setincludeActive] = React.useState(true);
	const [includeInactive, setincludeInactive] = React.useState(false);
	const [includePending, setincludePending] = React.useState(false);
	const [includeFailed, setincludeFailed] = React.useState(false);
	const [disableSearch, setdisableSearch] = React.useState(false);
	const [showStatusDd, setshowStatusDd] = React.useState(initialScope === "Internal");
	const [startOptionValue, setstartOptionValue] = React.useState([]);

	const [startDate, setstartDate] = React.useState(() => { const d = new Date(); d.setMonth(d.getMonth() - 1); return d; });
	const [endDate, setendDate] = React.useState(new Date());

	// Timeframe presets relative to today; "SpecifyRange" reveals the Start/End pickers.
	const MIN_DATE = new Date(1900, 0, 1);
	const [timeframe, settimeframe] = React.useState("LastMonth");
	const [showCustomRange, setshowCustomRange] = React.useState(false);
	const timeframeOptions = [
		{ value: "LastMonth", label: props.localizations.LastMonth },
		{ value: "LastSixMonths", label: props.localizations.LastSixMonths },
		{ value: "LastYear", label: props.localizations.LastYear },
		{ value: "IncludeAll", label: props.localizations.IncludeAll },
		{ value: "SpecifyRange", label: props.localizations.SpecifyRange },
	];

	const startForTimeframe = (tf) => {
		const d = new Date();
		switch (tf) {
			case "LastSixMonths": d.setMonth(d.getMonth() - 6); return d;
			case "LastYear": d.setFullYear(d.getFullYear() - 1); return d;
			case "IncludeAll": return new Date(MIN_DATE);
			case "LastMonth":
			default: d.setMonth(d.getMonth() - 1); return d;
		}
	};

	const handleTimeframeChange = (e) => {
		const tf = e.target.value.value;
		settimeframe(tf);
		if (tf === "SpecifyRange") {
			setshowCustomRange(true);
			// Coming from "Include All" would leave a 1900 start in the picker; reset to a sensible range.
			if (startDate.getFullYear() < 1990) {
				setstartDate(startForTimeframe("LastMonth"));
				setendDate(new Date());
			}
		} else {
			setshowCustomRange(false);
			setstartDate(startForTimeframe(tf));
			setendDate(new Date());
		}
	};

	const handleincludeChange = (e) => {
		setstartOptionValue(e.value);
		setincludeActive(e.value.find(x => x.value === 1) != null);
		setincludeInactive(e.value.find(x => x.value === 2) != null);
		setincludePending(e.value.find(x => x.value === 3) != null);
		setincludeFailed(e.value.find(x => x.value === 4) != null);
		setdisableSearch(e.value.length === 0);
	}

	const changestartDate = (event) => { setstartDate(new Date(event.value)) };
	const changeendDate = (event) => { setendDate(new Date(event.value)) };

	const [dataResult, setDataResult] = React.useState(
		process(historyData, dataState)
	);
	const dataStateChange = (event) => {
		setDataResult(process(historyData, event.dataState));
		setDataState(event.dataState);
	};

	const { execute, result } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});

	const handleScopeChange = (e) => {
		const scope = e.target.value.value;
		setsearchScope(scope);
		setshowStatusDd(scope === "Internal");
		if (scope !== "Public")
			setselectedPortal(null);
	}

	const handlePortalChange = (e) => {
		const portal = e.target.value;
		// Clearing the dropdown returns to the full public scope (no portal filter).
		setselectedPortal(portal != null && portal.value != null ? portal : null);
	};

	const getPortals = () => {
		execute("GET", apiRoutes.publicSites.get)
			.then(json => {
				if (json && json.length !== 0)
					setportals(json
						.filter(x => x.filterName != null && x.filterName !== "")
						.map(x => ({ value: x.id, label: x.name, filterName: x.filterName })));
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const adjustFromTimezone = (dateString, timezoneId) => {
		let timezoneDate = new Date(dateString);
		if (timezoneId != null) {
			let timezone = timezones.find(x => x.timezoneId == timezoneId);
			if (timezone != null) {
				timezoneDate = timezoneDate.setHours(timezoneDate.getHours() - timezone.offset);
				timezoneDate = new Date(timezoneDate);
			}
		}
		return timezoneDate;
	};

	React.useEffect(() => {
		localStorage.removeItem("languages");
		if (props.localizations.IncludeActive != null) {
			setstartOptionValue([{ value: 1, label: props.localizations.IncludeActive }]);
			setbuttonsConfig([
				{
					type: 'secondary',
					icon: 'icon-ui-general-libraries',
					tooltip: props.localizations.Columns,
					position: "top",
					onClick: () => { setshowColumnSelect(true); }
				},
				{
					type: 'secondary',
					icon: 'icon-ui-general-download',
					tooltip: props.localizations.Download,
					position: "top",
					onClick: () => { setdownloadCsv(true); }
				}
			]);
			if (props.customer.DateFormatId != null) {
				let format = dateFormats.find((x) => x.value === props.customer.DateFormatId);
				if (format != null) {
					setdateFormatFilter(format.text + " hh:mm:ss a");
				}
			}
			if (props.currentTenent.CustomerId != null && !props.currentTenent.IsReviewHistoryUser)
				navigate("/NoPermissions");
		}
	}, [props.localizations]);

	React.useEffect(() => {
		if (execute != null)
			getPortals();
	}, [execute]);

	// Build the query string from the current search criteria; shared by the grid search and the export.
	const buildHistoryParams = () => {
		const pad = (num, size = 2) => String(num).padStart(size, '0');
		let endParam;
		if (showCustomRange) {
			// The picked End is a user-entered wall-clock interpreted in the site's timezone; convert to UTC.
			let endDateAdjusted = adjustFromTimezone(new Date(endDate), props.customer.TimezoneId);
			endParam = endDateAdjusted.getFullYear() + '-' +
				pad(endDateAdjusted.getMonth() + 1) + '-' +
				pad(endDateAdjusted.getDate()) + 'T' +
				pad(endDateAdjusted.getHours()) + ':' +
				pad(endDateAdjusted.getMinutes()) + ':' +
				pad(endDateAdjusted.getSeconds()) + '.' +
				'999';
		} else {
			// Presets mean "up to now": send the true UTC instant (timezone-independent; future records can't exist).
			const nowUtc = new Date();
			endParam = nowUtc.getUTCFullYear() + '-' +
				pad(nowUtc.getUTCMonth() + 1) + '-' +
				pad(nowUtc.getUTCDate()) + 'T' +
				pad(nowUtc.getUTCHours()) + ':' +
				pad(nowUtc.getUTCMinutes()) + ':' +
				pad(nowUtc.getUTCSeconds()) + '.' +
				'999';
		}
		let startDateAdjusted = adjustFromTimezone(new Date(startDate), props.customer.TimezoneId);
		startDateAdjusted = startDateAdjusted.getFullYear() + '-' +
			pad(startDateAdjusted.getMonth() + 1) + '-' +
			pad(startDateAdjusted.getDate()) + 'T' +
			pad(startDateAdjusted.getHours()) + ':' +
			pad(startDateAdjusted.getMinutes()) + ':' +
			pad(startDateAdjusted.getSeconds()) + '.' +
			'000';
		let params = `periodBeginDate=` + startDateAdjusted + `&periodEndDate=` + endParam + `&includeActive=` +
			includeActive + `&includeInactive=` + includeInactive + `&includePending=` + includePending + `&includeFailed=` + includeFailed + `&scope=` + searchScope;
		if (searchScope === "Public" && selectedPortal != null)
			params += `&publicSiteId=` + selectedPortal.value;
		return params;
	};

	// Stream the complete dataset (uncapped) from the server as CSV, applying the same criteria as the grid search.
	const exportHistory = async () => {
		if (result == null) return;
		try {
			setPending(true);
			const response = await fetch(`${apiRoutes.documents.historyExport}?${buildHistoryParams()}`, {
				method: "GET",
				headers: { Authorization: `Bearer ${result.accessToken}` }
			});
			if (!response.ok) {
				console.log(`Export failed: ${response.status}`);
				return;
			}
			const blob = await response.blob();
			const objectUrl = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = objectUrl;
			a.download = "review-history.csv";
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(objectUrl);

			// The server caps the export; surface a message when the result was truncated.
			if (response.headers.get("X-Export-Truncated") === "true") {
				const max = parseInt(response.headers.get("X-Export-Max-Rows") || "0", 10);
				const template = props.localizations.ExportRowLimitMessage || "Export limited to {0} rows; narrow your timeframe or scope for the remainder.";
				setExportInfoMsg(template.replace("{0}", max.toLocaleString()));
				setShowExportInfo(true);
			}
		} catch (err) {
			console.log(err);
		} finally {
			setPending(false);
		}
	};

	React.useEffect(() => {
		if (downloadCsv) {
			exportHistory();
			setdownloadCsv(false);
		}
	}, [downloadCsv]);

	const getData = () => {
		setPending(true);
		let historyUrl = `${apiRoutes.documents.history}?${buildHistoryParams()}`;
		execute("GET", historyUrl)
			.then(json => {
				if (json != null) {
					json.forEach((doc) => {
						doc.statusText = statusTypes.find(x => x.statusId === doc.status).status;
						if (doc.status === 2 || doc.status === 3)
							doc.materialId = null;

						doc.languagesText = doc.languages.map((x) => x.languageName + "-" + x.country).join(', ');

						if (doc.regulatoryJurisdiction == null || doc.regulatoryJurisdiction === "")
							doc.regulatoryJurisdiction = props.localizations.Global;

						doc.revisionDateDisplay = new Date(new Date(doc.revisionDate).toDateString());
						doc.revisionDate = new Date(new Date(doc.revisionDate).toDateString());

						if (doc.documentDate1 != null && doc.documentDate1 != '0001-01-01T00:00:00') {
							let length = (doc.documentDate1.indexOf("+") > 0) ? doc.documentDate1.indexOf("+") : doc.documentDate1.length;
							let timeExists = doc.documentDate1.indexOf("00000") <= 0 && doc.documentDate1.indexOf("00:00:00") <= 0;
							doc.documentDate1Display = (!timeExists) ? new Date(new Date(doc.documentDate1).toDateString()) : adjustForTimezone(doc.documentDate1.substring(0, length), 0);
							doc.documentDate1 = (!timeExists) ? new Date(new Date(doc.documentDate1).toDateString()) : adjustForTimezone(doc.documentDate1.substring(0, length), 0);
						}
						else {
							doc.documentDate1 = "";
							doc.documentDate1Display = "";
						}

						doc.timestamp_CreateDisplay = adjustForTimezone(doc.timestamp_Create.substring(0, doc.timestamp_Create.indexOf("+")), props.customer.TimezoneId);
						doc.timestamp_Create = adjustForTimezone(doc.timestamp_Create.substring(0, doc.timestamp_Create.indexOf("+")), props.customer.TimezoneId);
						if (doc.timestamp_Modified != null) {
							doc.timestamp_ModifiedDisplay = adjustForTimezone(doc.timestamp_Modified.substring(0, doc.timestamp_Modified.indexOf("+")), props.customer.TimezoneId);
							doc.timestamp_Modified = adjustForTimezone(doc.timestamp_Modified.substring(0, doc.timestamp_Modified.indexOf("+")), props.customer.TimezoneId);
						}
					});
					sethistoryData(json);

					setDataResult(process(json, { skip: 0, take: 25 }));
					setDataState({ skip: 0, take: 25 });
					setPending(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	return (
		<Layout versionNumber={props.versionNumber} buttonsConfig={buttonsConfig} currentTenent={props.currentTenent} localizations={props.localizations} changeLanguage={props.changeLanguage} languageValue={props.languageValue} info={showExportInfo} setInfo={setShowExportInfo} infoMessage={exportInfoMsg} >
			<div className="dsCriteriaDiv dsHistoryCriteria" >
				<div className="dsCriteriaField">
					<label className="dsCriteriaLabel">{props.localizations.SelectTimeframe}</label>
					<SpheraDropdownEx
						className="timeframeDropdown"
						options={timeframeOptions}
						value={timeframeOptions.find((x) => x.value === timeframe)}
						textField="label"
						dataItemKey="value"
						onChange={handleTimeframeChange}
						width="225px"
					/>
				</div>
				{showCustomRange &&
					<>
						<div className="dsCriteriaField">
							<label className="dsCriteriaLabel">{props.localizations.Start}</label>
							<DatePicker
								className="dsStartDate"
								width={225}
								max={endDate}
								format={dateFormatFilter}
								value={startDate}
								onChange={changestartDate}
								navigation={false}
							/>
						</div>
						<div className="dsCriteriaField">
							<label className="dsCriteriaLabel">{props.localizations.End}</label>
							<DatePicker
								className="dsEndDate"
								width={225}
								min={startDate}
								max={maxDate}
								format={dateFormatFilter}
								value={endDate}
								onChange={changeendDate}
								navigation={false}
							/>
						</div>
					</>
				}
				<div className="dsCriteriaField">
					<label className="dsCriteriaLabel">{props.localizations.Scope}</label>
					<SpheraDropdownEx
						className="searchScopeDropdown"
						options={scopeOptions}
						value={scopeOptions.find((x) => x.value === searchScope)}
						textField="label"
						dataItemKey="value"
						onChange={handleScopeChange}
						width="225px"
					/>
				</div>
				{showStatusDd &&
					<div className="dsCriteriaField">
						<label className="dsCriteriaLabel">{props.localizations.Status}</label>
						<SpheraDropdownEx
							className="includeStatusDropdown"
							type="multi-select"
							value={startOptionValue}
							options={options}
							width="600px"
							onChange={handleincludeChange}
						/>
					</div>
				}
				{searchScope === "Public" &&
					<div className="dsCriteriaField">
						<label className="dsCriteriaLabel">{props.localizations.CustomerPortal}</label>
						<SpheraTooltip position="top" title={props.localizations.OnlyDocumentLevelFilters}>
							<SpheraDropdownEx
								className="portalFilterDropdown"
								options={portals}
								value={selectedPortal}
								textField="label"
								dataItemKey="value"
								onChange={handlePortalChange}
								onRemoveChange={() => setselectedPortal(null)}
								removable
								placeholder={props.localizations.AllPublicDocuments}
								width="600px"
							/>
						</SpheraTooltip>
					</div>
				}
			</div>
			<div className="dsCriteriaButtonDiv">
				<SpheraButtonEx text={props.localizations.Search} primary onClick={getData} disabled={disableSearch} />
			</div>
			<div>
				<HistoryGrid searchArchive={searchScope === "Archived"} customer={props.customer} dateFormatId={props.customer.DateFormatId} localizations={props.localizations}
					pending={pending} historyData={historyData} dataState={dataState} dataResult={dataResult} dataStateChange={dataStateChange}
					showColumnSelect={showColumnSelect} setshowColumnSelect={setshowColumnSelect}/>
			</div>
		</Layout>
	);
}
